import { GROUP_TRIP_VISIBILITY_OPTIONS } from './groupTripPresentation';

export default function GroupTripDraftForm({
  formId,
  publicationId,
  showPublicationId = false,
  recruitmentTitle,
  onRecruitmentTitleChange,
  summary,
  onSummaryChange,
  capacity,
  onCapacityChange,
  startAt,
  onStartAtChange,
  endAt,
  onEndAtChange,
  visibility,
  onVisibilityChange,
  disabled = false,
  datesLocked = false,
  t,
}) {
  return (
    <>
      {showPublicationId ? (
        <label htmlFor={`${formId}-publication`}>
          {t('travel.groupTrip.publicationIdLabel')}
          <input id={`${formId}-publication`} value={publicationId} readOnly />
        </label>
      ) : null}
      <label htmlFor={`${formId}-title`}>
        {t('travel.groupTrip.recruitmentTitleLabel')}
        <input
          id={`${formId}-title`}
          value={recruitmentTitle}
          onChange={(event) => onRecruitmentTitleChange(event.target.value)}
          maxLength={200}
          required
          disabled={disabled}
        />
      </label>
      <label htmlFor={`${formId}-summary`}>
        {t('travel.groupTrip.summaryLabel')}
        <textarea
          id={`${formId}-summary`}
          value={summary}
          onChange={(event) => onSummaryChange(event.target.value)}
          maxLength={2000}
          disabled={disabled}
        />
      </label>
      <label htmlFor={`${formId}-capacity`}>
        {t('travel.groupTrip.capacityLabel')}
        <input
          id={`${formId}-capacity`}
          type="number"
          min="1"
          max="10000"
          value={capacity}
          onChange={(event) => onCapacityChange(event.target.value)}
          disabled={disabled}
        />
      </label>
      <label htmlFor={`${formId}-start`}>
        {t('travel.groupTrip.startAtLabel')}
        <input
          id={`${formId}-start`}
          readOnly={datesLocked}
          type="datetime-local"
          value={startAt}
          onChange={(event) => onStartAtChange(event.target.value)}
          required
          disabled={disabled}
        />
      </label>
      <label htmlFor={`${formId}-end`}>
        {t('travel.groupTrip.endAtLabel')}
        <input
          id={`${formId}-end`}
          readOnly={datesLocked}
          type="datetime-local"
          value={endAt}
          onChange={(event) => onEndAtChange(event.target.value)}
          required
          disabled={disabled}
        />
      </label>
      <label htmlFor={`${formId}-visibility`}>
        {t('travel.groupTrip.visibilityLabel')}
        <select
          id={`${formId}-visibility`}
          value={visibility}
          onChange={(event) => onVisibilityChange(event.target.value)}
          disabled={disabled}
        >
          {GROUP_TRIP_VISIBILITY_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </label>
    </>
  );
}
